import { useLocation } from "react-router-dom";
import "../../css/terms.css";
import { useAtom } from "jotai";
import { headerText } from "../../App";
import { useEffect } from "react";

const PrivacyPolicy = () => {
  const location = useLocation();

  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);

  useEffect(() => {
    setHeaderTextAtom("개인정보처리방침");
  }, [location?.state]);
  return (
    <>
      <div className="container container-terms">
        <h1 className="terms_heading_main">탑탑 개인정보처리방침</h1>
        <p>
        ㈜어셈브릭스(이하 “회사”)는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 
        개인정보보호법 등 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자의 권익 보호에 최선을 다하고 있습니다.<br/>
        </p>

        <p>
        회사의 개인정보처리방침은 회사가 제공하는 “탑탑” 관련 제반 서비스 
        (홈페이지, 모바일 웹/앱 포함)이용에 적용되며 다음과 같은 내용을 담고 있습니다.
          <ol>
            <li>수집하는 개인정보의 항목 및 수집방법</li>
            <li>개인정보의 수집 및 이용목적</li>
            <li>개인정보의 공유 및 제공</li>
            <li>개인정보의 처리위탁</li>
            <li>개인정보의 보유 및 이용기간</li>
            <li>개인정보의 파기절차 및 방법</li>
            <li>만 14세 미만 아동의 개인정보보호</li>
            <li>온라인 맞춤형 광고 서비스</li>
            <li>이용자의 권리와 그 행사방법</li>
            <li>개인정보 자동수집 장치의 설치/운영 및 거부에 관한 사항</li>
            <li>개인정보의 기술적/관리적 보호 대책</li>
            <li>개인정보보호책임자 및 담당자의 연락처</li>
            <li>기타</li>
            <li>개인위치정보의 처리</li>
            <li>고지의 의무</li>
          </ol>
        </p>

        <h6 className="terms_sub_heading">
          1. 수집하는 개인정보의 항목 및 수집방법
        </h6>
        <p>
          <ul>
            <li>
              첫째, 회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수항목으로 수집하고 있습니다.
              <table>
                <thead>
                  <tr>
                    <th colSpan={2}>구분</th>
                    <th>개인정보 항목</th>
                    <th>근거</th>
                    <th>수집방법</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>회원가입</td>
                    <td>필수</td>
                    <td>성명, 아이디, 비밀번호, 휴대폰번호, 이메일</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>SNS 로그인</td>
                    <td>필수</td>
                    <td>각 SNS ID에 대한 임의 식별번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>카카오톡</td>
                  </tr>
                  <tr>
                    <td>팝니다/삽니다 거래신청</td>
                    <td>필수</td>
                    <td>성명, 휴대폰번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>팝니다/삽니다 매물등록</td>
                    <td>필수</td>
                    <td>성명, 휴대폰번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>팝니다/삽니다 주선면허</td>
                    <td>필수</td>
                    <td>성명, 휴대폰번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              둘째, 회사는 회원가입, 팝니다 및 삽니다 거래신청, 매물등록, 마케팅 및 광고 등 해당 서비스 제공 시 개인정보 수집에 대해 동의한 이용자에 한해서만 아래와 같은 정보들이 수집될 수 있습니다.
              <table>
                <thead>
                  <tr>
                    <th colSpan={2}>구분</th>
                    <th>개인정보 항목</th>
                    <th>근거</th>
                    <th>수집방법</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>회원가입</td>
                    <td>선택</td>
                    <td>지역, 가입경로</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>거래신청</td>
                    <td>선택</td>
                    <td>각 SNS ID에 대한 임의 식별번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>카카오톡</td>
                  </tr>
                  <tr>
                    <td>매물등록</td>
                    <td>선택</td>
                    <td>자동차 등록증, 사업자 등록증, 화물자동차운송사업허가증</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>마케팅, <br/>맞춤 서비스의 제공 및 광고</td>
                    <td>선택</td>
                    <td>성명, 휴대폰번호</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                  <tr>
                    <td>거래 시</td>
                    <td>필수</td>
                    <td>성사 시 별도 수집<br/>(사업자 등록증, 자동차등록증, 화물자동차운송사업허가증, 인감증명)</td>
                    <td>개인정보보호법 제15조 제1항 제1호</td>
                    <td>홈페이지, 모바일웹</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              셋째, 서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
              <br/>&nbsp; - 이용자의 브라우저 종류 및 OS, 검색어, 서비스 이용 기록 : 서비스이용에 대한 통계분석 
              <br/>&nbsp; - IP Adress, 쿠키, 방문일시, 서비스 이용기록, 불량 이용 기록, 기기정보
              <br/>&nbsp; - 결제기록 : 전자금융거래기록보관
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">2. 개인정보의 수집 및 이용목적</h6>
        <p>
          가. 수집하는 개인정보의 항목
          <br/>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
          <table>
            <thead>
              <tr>
                <th>구분</th>
                <th>개인정보 수집 및 이용 목적</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>회원관리</td>
                <td>회원제 서비스 제공, 개인식별, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한</td>
              </tr>
              <tr>
                <td>서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 대금정산</td>
                <td>컨텐츠 제공, 특정 맞춤 서비스 제공, 청구서 등 발송, 본인인증, 대금 결제, 요금 추심, 서류대행 서비스를 위한 본인확인, 분쟁조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달</td>
              </tr>
              <tr>
                <td>신규 서비스 개발 및 맞춤 서비스 제공 혜택/정보 수신</td>
                <td>신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계</td>
              </tr>
              <tr>
                <td>수집한 개인정보의 이용목적 구분</td>
                <td>- 성명, 아이디, 비밀번호: 회원제 서비스 이용에 따른 본인 확인절차에 이용<br/>
                    - 이메일, 전화번호, 연락처(전화번호, 휴대전화번호) : 고지사항 전달 및 본인의사확인, 불만처리, 사용자구분등 원활한 의사소통 경로의 확보
                </td>
              </tr>
            </tbody>
          </table>
        </p>

        <h6 className="terms_sub_heading">3. 개인정보의 제3자 제공</h6>
        <p>
          회사는 이용자의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
          <ul>
            <li>- 기타 법에 의해 요구된다고 선의로 판단되는 경우 (예. 관련 법령에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등)</li>
            <li>- 서비스 이용에 필요한 목적을 위해 이용자의 개인정보에 대해서 제3자에게 제공(별도 이용자의 동의 여부 확인)</li>
            <li><br />이용자가 온라인상의 게시판 등을 통해 기재한 인적사항을 제3자가 수집하는 경우가 있을 수 있으므로 이에 유의하시기 바랍니다. 이용자가 스스로 게시판 등을 통해 기재한 인적사항과 관련하여 회사는 어떠한 책임도 지지 않습니다.</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">4. 개인정보의 처리위탁</h6>
        <p>
          회사는 서비스 향상을 위해서 필요한 경우 및 기타 서비스 제공을 위해서 이용자의 개인정보를 아래와 같은 업무를 위탁하여 운영하고 있습니다.
          <br />
          수탁자에 대해서는 관련 법규 및 지침의 준수, 정보보호 및 비밀유지, 제3자제공금지, 사고 시 책임부담, 위탁기간 종료 즉시 개인정보의 반납.파기 의무 등을 규정하여 관리/감독하고 있습니다. 
          또한 회사는 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보처리방침을 통하여 공개 하도록 하겠습니다.
          <ul>
            <li>[개인정보처리의 위탁내역]</li>
            <li>
              <table>
                <thead>
                  <tr>
                    <th>수탁업체</th>
                    <th>위탁 업무</th>
                    <th>보유기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>카카오</td>
                    <td>본인확인</td>
                    <td>업체에서 이미 보유하고 있는 개인정보이기 때문에 ㈜어셈브릭스는 별도로 저장하지 않음</td>
                  </tr>                  
                </tbody>
              </table>
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">5. 개인정보의 보유 및 이용기간</h6>
        <p>
         회사는 이용자가 회원으로서 서비스를 이용하는 동안 이용자의 개인정보를 보유 및 이용하며, 이용자가 회원탈퇴를 요청한 경우나 개인정보의 수집 및 이용목적을 달성하거나 보유 및 이용기간이 종료한 경우 또는 사업폐지 등의 사유가 발생한 경우 해당 정보를 지체 없이 파기합니다.
         <br/>단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
         <ul>
           <li>가. 개인정보 보유 및 이용기간</li>
           <li>&nbsp;- 부정이용기록의 경우: 부정이용에 대한 적법한 절차 및 방지 작업이 종료된 때</li>
           <li>&nbsp;- 회원 가입 정보의 경우: 회원탈퇴 시 또는 회원 자격을 상실한 때</li>
           <li>&nbsp;- 설문조사, 이벤트 목적을 위해 수집한 경우: 해당 설문조사, 이벤트가 종료한 때</li>
           <li>&nbsp;- 기타보유정보: 정보의 수집 및 이용 목적이 달성된 때</li>
         </ul>
         <ul>
           <li>나. 관련법령에 의한 정보보호 사유</li>
           <li>상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.</li>
           <li>
            <table>
              <thead>
                <tr>
                  <th>대 상</th>
                  <th>관련 법 조항</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>계약 또는 청약철회 등에 관한 기록</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                  <td>5년</td>
                </tr>                  
                <tr>
                  <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                  <td>5년</td>
                </tr>
                <tr>
                  <td>고유식별정보에 관한 기록</td>
                  <td>전자상거래 등에서의 소비자 보호에 관한 법률, 국세 기본법 제26조의2</td>
                  <td>5년</td>
                </tr>
                <tr>
                  <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                  <td>3년</td>
                </tr>
                <tr>
                  <td>본인확인에 관한 기록</td>
                  <td>정보통신 이용촉진 및 정보보호 등에 관한 법률</td>
                  <td>6개월</td>
                </tr>
                <tr>
                  <td>컴퓨터 통신 및 인터넷 로그기록자료, 접속지 추적자료</td>
                  <td>통신비밀보호법 제15조의2 및 동법 시행령 제41조</td>
                  <td>3개월</td>
                </tr>
              </tbody>
            </table>
           </li>
         </ul>
        </p>

        <h6 className="terms_sub_heading">6. 개인정보 파기절차 및 방법</h6>
        <p>
          회사는 다른 법률에 따라 개인정보를 보존하여야 하는 경우가 아닌 한, 수집한 이용자의 개인정보의 수집 및 이용목적이 달성되거나, 가명정보의 처리기간 경과, 이용자가 회원탈퇴를 요청한 경우 지체 없이 파기하여 향후 어떠한 용도로도 열람 또는 이용할 수 없도록 처리합니다. 단, “5.개인정보의 보유 및 이용기간 가, 나”와 같은 예외 경우를 두고 있습니다.
          <br />
          회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
          <ul>
            <li>가. 파기절차 </li>
            <li>이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(5. 보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.</li>
            <li>동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
          </ul>
          <ul>
            <li>나. 파기방법 </li>
            <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하며, 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
          </ul>
          <ul>
            <li>미이용자의 개인정보 파기 등에 관한 조치 </li>
            <li>휴면회원의 개인정보는 다른 회원의 개인정보와 분리하여 별도로 저장/관리 되며, 분리 저장된 개인정보는 3년 보관기간 경과 후 파기하고 있습니다.</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">7. 만 14세 미만 아동의 개인정보보호</h6>
        <p>
          회사가 운영하는 사이트에서는 만14세 미만 아동의 경우 회원 가입이 불가능합니다.
        </p>

        <h6 className="terms_sub_heading">8. 온라인 맞춤형 광고 서비스</h6>
        <p>
          회사는 서비스 이용과정에서 고객에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를 수집/이용하고 있습니다.
          <table>
            <tbody>
              <tr>
                <td>수집하는 행태정보의 항목</td>
                <td>고객의 탑탑 웹/앱 서비스 방문이력, 검색이력, 구매이력</td>
              </tr>                  
              <tr>
                <td>행태정보의 수집방법</td>
                <td>고객의 탑탑 웹/앱 서비스 방문/실행 시 자동수집</td>
              </tr>
              <tr>
                <td>행태정보 수집목적</td>
                <td>
                  - 고객 개인의 관심 분야에 따른 정보 제공
                  <br/>- 접속빈도 또는 방문시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타겟 마케팅 및 서비스 개선 척도로 활용
                  <br/>- 검색한 품목들에 대한 정보와 관심있게 둘러본 품목을 추적하여 개인 맞춤 매물 및 정보 추천
                </td>
              </tr>
              <tr>
                <td>이용자 통제권 행사방법</td>
                <td>
                  - 인터넷익스플로러의 경우, 웹브라우저 상단의 [도구]→[인터넷옵션]→[개인정보]→[고급] 메뉴를 통하여 쿠키 설정 거부
                  <br/> - Safari의 경우, Mac OS 상단 좌측 메뉴바에서 [Safari]→[환경설정]→[보안]을 통하여 쿠키 허용 여부 설정
                  <br/> - 안드로이드 계열: 설정→애플리케이션→'탑탑'앱 선택→권한→접근항목별 '허용' 또는 '허용안함' 체크
                  <br/> - ios 계열: 설정→'탑탑'앱 선택→접근권한 별 동의 또는 철회 체크
                </td>
              </tr>
            </tbody>
          </table>
        </p>

        <h6 className="terms_sub_heading">9. 이용자의 권리와 그 행사방법</h6>
        <p>
          이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.
          <ul>
            <li>이용자는 개인정보관리책임자에게 완전히 자동화된 개인정보 처리에 따른 결정을 거부하거나 그에 대한 설명 등을 요청하실 수 있습니다.</li>
          </ul>
          <ul>
            <li>이용자의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입해지(동의철회)를 위해서는 ’회원탈퇴’를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.</li>
          </ul>
          <ul>
            <li>혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.</li>
          </ul>
          <ul>
            <li>회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "5. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</li>
          </ul>
          <ul>
            <li>이용자는 자신의 개인정보의 처리 여부를 확인할 수 있으며 개인정보에 대한 열람 및 전송을 요청할 수도 있습니다.</li>
          </ul>
          <ul>
            <li>단, 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 권리 행사를 하실 경우 위임장을 제출하셔야 합니다.</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">10. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h6>
        <p>
          회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는 데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.
          <ul>
            <li>가. 쿠키의 사용 목적</li>
            <li>
              이용자들이 방문한 회사의 각 서비스와 웹 사이트들에 대한 로그인 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다. 또한 이용자의 접속 빈도나 방문 시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타겟(Target) 마케팅 및 서비스 개편 등의 척도로 활용합니다.
            </li>
          </ul>
          <ul>
            <li>나. 쿠키의 설치/운영 및 거부</li>
            <li>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</li>
            <li>쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</li>
          </ul>
          <ul>
            <li>웹 브라우저(쿠키 설정)</li>
            <li>&nbsp;- Internet Explorer: 메뉴 {">"} 도구 {">"} 인터넷옵션 {">"} 일반 {">"} 검색 기록 {">"} ‘삭제’ 및 ‘설정’</li>
            <li>&nbsp;- Chrome: 메뉴 {">"} 설정 {">"} ‘개인정보 및 보안’</li>
            <li>&nbsp;- Safari: 환경설정 {">"} ‘크로스 사이트 추적 방지’ 및 ‘모든 쿠키 차단’</li>
            <li>&nbsp;- 이 외에도 Firefox, Opera 등 주요 인터넷 웹브라우저들도 쿠키 삭제 기능을 제공하고 있습니다.</li>
          </ul>
          <ul>
            <li>모바일 웹, 앱(쿠키, 광고식별)</li>
            <li>&nbsp;- Android: 디바이스 설정 {">"} Google {">"} 광고 {">"} 광고 맞춤설정 선택 해제 (ON)</li>
            <li>&nbsp;- iPhone: 디바이스 설정 {">"}개인 정보 보호 {">"} 추적 {">"} 앱이 추적을 요청하도록 허용 (OFF)</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">11. 개인정보의 기술적/관리적 보호 대책</h6>
        <p>
          회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.
          <ul>
            <li>가. 개인정보 암호화</li>
            <li>이용자의 주요 개인정보는 암호화하여 저장하고 있으며, 파일 및 전송데이터를 암호화하여 혹시 발생할 수 있는 사고 시라도 이용자의 개인정보가 유출되지 않도록 관리되고 있습니다.</li>
          </ul>
          <ul>
            <li>나. 해킹 등에 대비한 대책</li>
            <li>회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 24시간 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다</li>
          </ul>
          <ul>
            <li>다. 처리 직원의 최소화 및 교육</li>
            <li>회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다.</li>
          </ul>
          <ul>
            <li>라. 개인정보보호전담기구의 운영</li>
            <li>사내 개인정보보호전담기구 등을 통하여 회사의 개인정보처리방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 회사가 개인정보보호 의무를 다 하였음에도 불구하고 이용자 본인의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는 회사는 책임을 지지 않습니다.</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">12. 개인정보보호 책임자 및 담당자의 연락처</h6>
        <p>
          회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보보호책임자 및 담당자를 지정하고 있고, 연락처는 아래와 같습니다.
          <ul>
            <li>가. 개인정보보호책임자</li>
            <li>이름 : 강신장</li>
            <li>소속 : 정보보호담당</li>
            <li>E-MAIL : sh.kang@assembrix.co.kr</li>
          </ul>
          <ul>
            <li>나. 개인정보보호담당자</li>
            <li>
              <table>
                <thead>
                  <tr>
                    <th>사이트</th>
                    <th>담당자</th>
                    <th>소속/직위</th>
                    <th>E-Mail</th>
                    <th>전화번호</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>탑탑(www.top-top.kr)</td>
                    <td>강신장</td>
                    <td>정보보안팀/상무</td>
                    <td>sh.kang@assembrix.co.kr</td>
                    <td>010-4478-8944</td>
                  </tr> 
                </tbody>
              </table>
            </li>
            <li><br/>이용자는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</li>
            <li>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</li>
            <li>- 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
            <li>- 개인정보분쟁조정위원회 (www.kopico.go.kr / 국번없이 1833-6972)</li>
            <li>- 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</li>
            <li>- 사이버범죄 신고시스템 (ecrm.police.go.kr / 국번없이 182)</li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">13. 기타</h6>
        <p>
          회사가 운영하는 사이트에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "탑탑 개인정보처리방침"이 적용되지 않음을 알려 드립니다.
        </p>

        <h6 className="terms_sub_heading">14. 고지의 의무</h6>
        <p>
          현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 변경이유 및 내용을 홈페이지의 '공지사항'을 통해 고지할 것입니다.
        </p>
        <p>
          본 개인정보처리방침의 내용은 수시로 변경될 수 있으므로 사이트를 방문하실 때마다, 이를 확인하시기 바랍니다.
          <ul>
            <li>- 개인정보처리방침 버전번호 : Ver 1.0</li>
            <li>- 공고일자 : 2025년 06월 01일</li>
            <li>- 시행일자 : 2025년 06월 01일</li>
          </ul>
        </p>
      </div>
    </>
  );
};
export default PrivacyPolicy;
